import { render, staticRenderFns } from "./CurrenciesIndex.vue?vue&type=template&id=51aed455"
import script from "./CurrenciesIndex.vue?vue&type=script&lang=js"
export * from "./CurrenciesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports